/* NEDISO Anfragekorb
 *
 * Zweiter Korb neben dem Warenkorb. Der Warenkorb fuehrt zur Kasse, dieser
 * fuehrt zu einem Angebot von Hand.
 *
 * Grund fuer die Trennung: im Projektgeschaeft lautet die Anfrage "zwanzig von
 * denen und fuenf von denen, was kostet das". Das ist kein Kauf, sondern eine
 * Preisanfrage, und sie darf den Warenkorb nicht belegen. Ein Kunde, der beides
 * gleichzeitig macht, soll seine Direktbestellung nicht verlieren.
 *
 * Der Zustand liegt in localStorage, nicht im Shopify-Warenkorb. Damit kostet
 * das Ganze kein App-Abo und keinen Serverzustand. Preis dafuer: die Liste
 * gehoert dem Geraet, nicht dem Konto, und ueberlebt keinen Geraetewechsel.
 * Fuer eine Anfrage, die in derselben Sitzung abgeschickt wird, reicht das.
 */
(function () {
  "use strict";

  var KEY = "nediso:anfrage";
  var MAX = 60; // Eine Projektanfrage mit mehr Positionen kommt als Datei.

  // localStorage wirft im privaten Modus mancher Browser beim Schreiben, nicht
  // erst beim Lesen. Deshalb faellt alles auf einen Speicher im Arbeitsspeicher
  // zurueck: die Liste ueberlebt dann keinen Seitenwechsel, aber die Seite
  // bleibt bedienbar statt mit einem Fehler stehenzubleiben.
  var ersatz = null;
  function lesen() {
    if (ersatz) return ersatz;
    try {
      return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch (e) {
      return [];
    }
  }
  function schreiben(liste) {
    try {
      localStorage.setItem(KEY, JSON.stringify(liste));
    } catch (e) {
      ersatz = liste;
    }
    melden();
  }

  function melden() {
    var n = anzahl();
    document.querySelectorAll("[data-anfrage-zaehler]").forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
    document.dispatchEvent(new CustomEvent("nd:anfrage", { detail: { anzahl: n } }));
  }

  function anzahl() {
    return lesen().length;
  }

  function hinzufuegen(posten) {
    if (!posten || !posten.handle) return false;
    var liste = lesen();
    var da = liste.filter(function (x) {
      return x.handle === posten.handle;
    })[0];
    if (da) {
      // Zweimal derselbe Artikel erhoeht die Menge, statt eine zweite Zeile
      // anzulegen. Eine Anfrage mit "Displayhalterung" zweimal untereinander
      // sieht nach Versehen aus.
      da.menge = Math.min(9999, (parseInt(da.menge, 10) || 1) + (posten.menge || 1));
    } else {
      if (liste.length >= MAX) return false;
      liste.push({
        handle: posten.handle,
        titel: posten.titel || posten.handle,
        sku: posten.sku || "",
        vendor: posten.vendor || "",
        preis: posten.preis || "",
        menge: posten.menge || 1
      });
    }
    schreiben(liste);
    return true;
  }

  function entfernen(handle) {
    schreiben(
      lesen().filter(function (x) {
        return x.handle !== handle;
      })
    );
  }

  function mengeSetzen(handle, n) {
    n = parseInt(n, 10);
    if (!(n > 0)) n = 1;
    var liste = lesen();
    liste.forEach(function (x) {
      if (x.handle === handle) x.menge = Math.min(9999, n);
    });
    schreiben(liste);
  }

  function leeren() {
    schreiben([]);
  }

  window.ndAnfrage = {
    liste: lesen,
    anzahl: anzahl,
    hinzufuegen: hinzufuegen,
    entfernen: entfernen,
    mengeSetzen: mengeSetzen,
    leeren: leeren
  };

  // Knoepfe im Katalog. Delegiert, damit auch nachgeladene Produktkarten
  // funktionieren, ohne dass jemand daran denken muss.
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-anfrage-add]");
    if (!btn) return;
    e.preventDefault();
    var ok = hinzufuegen({
      handle: btn.getAttribute("data-handle"),
      titel: btn.getAttribute("data-titel"),
      sku: btn.getAttribute("data-sku"),
      vendor: btn.getAttribute("data-vendor"),
      preis: btn.getAttribute("data-preis"),
      menge: parseInt(btn.getAttribute("data-menge"), 10) || 1
    });
    var alt = btn.getAttribute("data-label") || btn.textContent.trim();
    btn.setAttribute("data-label", alt);
    btn.textContent = ok ? "Auf der Anfrageliste" : "Liste ist voll";
    btn.classList.toggle("is-drin", ok);
    setTimeout(function () {
      btn.textContent = alt;
      btn.classList.remove("is-drin");
    }, 1800);
  });

  document.addEventListener("DOMContentLoaded", melden);
  if (document.readyState !== "loading") melden();
})();
